import { render, staticRenderFns } from "./shippedPorder.vue?vue&type=template&id=3901d84b&scoped=true&"
import script from "./shippedPorder.vue?vue&type=script&lang=js&"
export * from "./shippedPorder.vue?vue&type=script&lang=js&"
import style0 from "./shippedPorder.vue?vue&type=style&index=0&id=3901d84b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901d84b",
  null
  
)

export default component.exports